import { Text } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";
import "../BackgroundImageCard/BackgroundImageCard.scss";

const CardBox = (props: any): JSX.Element => {
  return (
    <div
      className={
        props?.animationClass && props?.enteredWaypoint
          ? props.animationClass + " CardBox"
          : props.cssClass
          ? props.cssClass + " CardBox"
          : "CardBox"
      }
      style={props.isHidden ? { overflow: "hidden" } : {}}
    >
      {props.cardContent}
    </div>
  );
};

export default CardBox;
